import { render } from "./MembershipDetailsPaymentsTab.vue?vue&type=template&id=4ff5837a"
import script from "./MembershipDetailsPaymentsTab.vue?vue&type=script&lang=js"
export * from "./MembershipDetailsPaymentsTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__